import script from "./log-information-zone.vue?vue&type=script&lang=ts&setup=true"
export * from "./log-information-zone.vue?vue&type=script&lang=ts&setup=true"

import "./log-information-zone.vue?vue&type=style&index=0&id=31d5974d&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d5974d"]])

export default __exports__